import { render, staticRenderFns } from "./PopOrderFanjian.vue?vue&type=template&id=042d2ffd&scoped=true&"
import script from "./PopOrderFanjian.vue?vue&type=script&lang=js&"
export * from "./PopOrderFanjian.vue?vue&type=script&lang=js&"
import style0 from "./PopOrderFanjian.vue?vue&type=style&index=0&id=042d2ffd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042d2ffd",
  null
  
)

export default component.exports